.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
  inline-size: 100%;
  max-inline-size: var(--content-max);
  margin-inline: auto;
  padding-block: var(--space-6) var(--space-12);
  padding-inline: var(--gutter);
  min-inline-size: 0;
}

.narrow {
  max-inline-size: 60rem;
}

.header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--space-4);
  padding-block-end: var(--space-4);
  border-block-end: var(--border-width) solid var(--color-rule);
}

.headerText {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-inline-size: 0;
}

.eyebrow {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  color: var(--color-accent-text);
  font-size: var(--text-xs);
  font-weight: var(--weight-semibold);
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.eyebrow a {
  color: inherit;
  text-decoration: none;
}

.eyebrow a:hover {
  text-decoration: underline;
}

.title {
  font-size: var(--text-2xl);
  font-weight: var(--weight-bold);
  overflow-wrap: anywhere;
}

.subtitle {
  color: var(--color-text-muted);
  max-inline-size: 48rem;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
}

.panel {
  display: flex;
  flex-direction: column;
  min-inline-size: 0;
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-surface);
}

.panelHeader {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  padding: var(--space-4) var(--space-5);
  border-block-end: var(--border-width) solid var(--color-rule);
}

.panelTitleGroup {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-inline-size: 0;
}

.panelTitle {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  font-size: var(--text-lg);
}

.panelDescription {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
}

.panelBody {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: var(--space-5);
  min-inline-size: 0;
}

.panelBodyFlush {
  padding: 0;
}

.formActions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--space-2);
}

.stack {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  min-inline-size: 0;
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--space-3);
}

.toolbar > * {
  flex: 1 1 12rem;
  min-inline-size: 0;
}

.toolbar > .toolbarWide {
  flex: 3 1 18rem;
}

.toolbar > .toolbarAction {
  flex: 0 0 auto;
}

.dl {
  display: grid;
  grid-template-columns: minmax(8rem, max-content) 1fr;
  gap: var(--space-2) var(--space-6);
  margin: 0;
}

.dl dt {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
}

.dl dd {
  margin: 0;
  min-inline-size: 0;
  overflow-wrap: anywhere;
}

@media (max-width: 40rem) {
  .dl {
    grid-template-columns: 1fr;
    gap: 0;
  }

  .dl dd {
    margin-block-end: var(--space-2);
  }

  .title {
    font-size: var(--text-xl);
  }

  .header {
    align-items: stretch;
  }

  .actions {
    inline-size: 100%;
  }
}

.money {
  font-variant-numeric: tabular-nums lining-nums;
  unicode-bidi: isolate;
  white-space: nowrap;
}

.code {
  font-family: var(--font-mono);
  font-size: 0.9em;
  direction: ltr;
  unicode-bidi: isolate;
}

.muted {
  color: var(--color-text-muted);
}

.loadingPage {
  display: grid;
  place-items: center;
  min-block-size: 40vh;
  color: var(--color-text-muted);
}
